var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCmf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 70,
    viewBox: "0 0 94 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.603 2.78418H6.25691C4.9433 2.78418 3.87842 3.84054 3.87842 5.14362V64.7166C3.87842 66.0196 4.9433 67.076 6.25691 67.076H89.603C90.9166 67.076 91.9815 66.0196 91.9815 64.7166V5.14362C91.9815 3.84054 90.9166 2.78418 89.603 2.78418Z",
    stroke: "#733FE7",
    strokeWidth: 0.830695,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0377 58.2807C71.6212 58.2807 73.7155 56.2032 73.7155 53.6404C73.7155 51.0776 71.6212 49 69.0377 49C66.4542 49 64.3599 51.0776 64.3599 53.6404C64.3599 56.2032 66.4542 58.2807 69.0377 58.2807Z",
    fill: "#733FE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6921 62.1334L69.0914 53.6143L64 62.1334",
    stroke: "#733FE7",
    strokeWidth: 2.28441,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 31H78",
    stroke: "#733FE7",
    strokeWidth: 2.28441,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 37H78",
    stroke: "#733FE7",
    strokeWidth: 2.28441,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 43H78",
    stroke: "#733FE7",
    strokeWidth: 2.28441,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31 19L67 19",
    stroke: "#733FE7",
    strokeWidth: 2.28441,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39 14L59 14",
    stroke: "#733FE7",
    strokeWidth: 2.28441,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20 52H40",
    stroke: "#733FE7",
    strokeWidth: 2.28441,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmf);
export default __webpack_public_path__ + "static/media/cmf.2c049e86.svg";
export { ForwardRef as ReactComponent };